module.exports = __webpack_public_path__ + "static/media/consorcio-imovel-anage.24f78e90.png";